<div class="pdf-container">
    <pdf-viewer 
    id="pdf-viewer"
    [src]="pdfFile" 
    [show-borders]="true"
    [original-size]="false"
    [autoresize]="true"
    [zoom]="zoomValue"
    (page-rendered)="pageRendered($event)"
    (pages-initialized)="pageInitialized($event)"
    (error)="callErrorPdf($event)"
    >
    </pdf-viewer>
    <div class="zoomButtons" *ngIf="!error">
        <div *ngFor="let button of pdfButtons">
            <bc-icon-button
                [type]="'outline'"
                [color]="'white'" 
                [shadow]="true" 
                [size]="'xsmall'" 
                [customIcon]="button"
                (click)="clickPdfButton(button)"
            ></bc-icon-button>
        </div>
    </div>
</div>

<div class="checkAcceptButton">
    <bc-checkbox-group [formControl]="checkBoxGroup" >
        <bc-checkbox [label]="textAcceptButton"
            id="check-accept"
            [enabled]="enabledCheck"
            [isChecked]="true"
            (changeState)="changeCheckAccept($event)">
        </bc-checkbox>
      </bc-checkbox-group>
</div>

<div class="modal" *ngIf="openModal">
    <div class="modal-content">
        <span class="close" (click)="closeModal()">&times;</span>
        <pdf-viewer [src]="pdfFile" 
            [original-size]="false"
            [autoresize]="true"
            (page-rendered)="pageRendered($event)"
            (pages-initialized)="pageInitialized($event)"
            (error)="callErrorPdf($event)"
            >
        </pdf-viewer>
    </div>
</div>